<template>
  <v-app none class="white">

  <v-navigation-drawer v-if="user.sub_type || user.type"
    permanent="true"
    app
    overflow
    class="am-sidebar"
    width="235" style="overflow: visible;"
  >
  <div style="    min-height:75px;
    margin-top: 12px;">
  <v-img class="logoIImg" style="width:70%;" src="./assets/amara-black-logo.png"></v-img>
  </div>
  <v-divider></v-divider>
  <v-card
    class="mx-auto"
    max-width="300"
    tile
  >
    <v-list dense>
      <v-list-item-group
        v-model="selectedItem" mandatory
        color="primary"
      >
        <v-list-item
          v-for="(item, i) in items"
          :key="i" @click="changeTab(item.route)"
        >
          <v-list-item-icon style="margin-right: 12px;">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-menu bottom offset-y :style="{ zIndex: 9999 }">
            <template v-slot:activator="{ on, attrs }">
        <div
        class="menu-button"
        v-bind="attrs"
        v-on="on"
        style="height: 60px; width: 100%; cursor: pointer; display: flex; align-items: center; background-color: #6366f1; font-size: 16px; position: fixed; bottom: 0;"
        >
    <div style="width: 40px; height: 40px; margin: 10px;">
    <img
      v-if="user.user_profile.profilePicture"
      :src="user.user_profile.profilePicture"
      alt="Profile Picture"
      style="width: 100%; height: 100%; border-radius: 50%;"
    />
    <img
      v-else
      src="@/assets/dummy.png"
      alt="Dummy Image"
      style="width: 100%; height: 100%; border-radius: 50%;"
    />
  </div>
  <div>
    <div style="color: #fff">{{ user.user_profile.first_name }}</div>
    <div style="font-size: 14px; color: #fff">{{ user.user_profile.employee_id }}</div>
  </div>
</div>
    </template>
    <v-list style="border-radius: 6px;padding-top:0px;">
      <v-list-item style="background-color: #10b981;color: white;">
        <v-list-item style="padding:0px !important">
  <div style="width: 40px; height: 40px; margin-right: 10px;">
    <img
      v-if="user.user_profile.profilePicture"
      :src="user.user_profile.profilePicture"
      alt="Profile Picture"
      style="width: 100%; height: 100%; border-radius: 50%;"
    />
    <img
      v-else
      src="@/assets/dummy.png"
      alt="Dummy Image"
      style="width: 100%; height: 100%; border-radius: 50%;"
    />
  </div>
  <v-list-item-content>
    <v-list-item-title style="font-size: 16px; color:white ; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
      {{ user.display_name }}
    </v-list-item-title>
    <v-list-item-title style="font-size: 14px; color: white; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; padding-top: 5px;">
      {{ user.email }}
    </v-list-item-title>
  </v-list-item-content>
</v-list-item>

      </v-list-item>
      <v-divider></v-divider>
      <v-list-item @click="logout()">
        <v-list-item-content>
          <v-list-item-title> <v-icon v-on="on" @click="logout()" style="padding: 5px;background: #e8e8e8;border-radius: 32px;color: #96969a;margin-right: 10px;">mdi-logout</v-icon>Log Out</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  </v-card>
  </v-navigation-drawer>
  <v-main>
    <v-snackbar
          :timeout="6000"
          :color="snackbar.color"
          :multi-line="snackbar.mode === 'multi-line'"
          :vertical="snackbar.mode === 'vertical'"
          v-model="snackbar.show"
        >
          <div class="d-flex justify-space-between align-center">
            <div>{{ snackbar.text }}</div>
            <v-btn text @click.native="snackbar.show = false">Close</v-btn>
          </div>
        </v-snackbar>
    <v-container fluid>
      <router-view />
    </v-container>
  </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import { mapState } from 'vuex';
Vue.use(VueSweetalert2);
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    selectedItem: 0,
      items: [
        { text: 'Executive View', icon: 'mdi-view-dashboard', route: '' },
        { text: 'Client Portfolio', icon: 'mdi-format-list-bulleted', route: 'company-list' },
        { text: 'Documents', icon: 'mdi-file-download', route: 'documents' },
        // { text: 'Revenue & ARR', icon: 'mdi-currency-usd', route: '' },
        { text: 'Support tickets', icon: 'mdi-help-circle', route: 'support-tickets' },
        { text: 'Activities', icon: 'mdi-file-tree', route: 'activities' },
        { text: 'Miscellaneous', icon: 'mdi-archive-cog', route: 'miscellaneous' },
      ],
        right: null,
        searchCompany: '',
    //
  }),
  computed: {
    ...mapState({
      snackbar: state => state.snackbar,
      user: state => state.user
    })
  },
  mounted() {
    console.log(this.$route.name);
    if (this.$route.name === 'dashboard') {
      this.selectedItem = 0;
    } else if (this.$route.name === 'companyList') {
      this.selectedItem = 1;
    } else if (this.$route.name === 'documents') {
      this.selectedItem = 2;
    } else if (this.$route.name === 'supportTickets') {
      this.selectedItem = 4;
    } else if (this.$route.name === 'activities') {
      this.selectedItem = 5;
    } else if (this.$route.name === 'miscellaneous') {
      this.selectedItem = 6;
    }
  },
  methods: {
    openModal () {
      console.log(this);
    },
    logout () {
      this.$swal({
        title: 'Log out ?',
        text: `You will be returned to the login screen.`,
        icon: 'warning',
        confirmButtonColor: '#10b981',
        showCancelButton: true,
        cancelButtonColor: '#d6d4d4',
        confirmButtonText: 'Log out'
      }).then((result) => {
        if (result.isConfirmed) {
        axios.post(`${process.env.VUE_APP_API_URL_FB}logout`, {}, {
          withCredentials: true
        }).then((response) => {
        if (response && response.data.status === 200) {
          this.$store.dispatch('deleteSession', 'logout');
          this.$router.push('/login');
        } else {
          this.$notify({
            group: 'foo',
            title: 'Error while logging out!',
            type: 'warn'
          });
          this.$store.dispatch('deleteSession', 'logout');
          this.$router.push('/login');
        }
      }, () => {
        this.$store.dispatch('deleteSession', 'logout');
        this.$router.push('/login');
      });
        }
      });
    },
    changeTab (url) {
      let baseUrl = `/${url}`;
      if (url === 'company-list') {
        this.selectedItem = 1
      } else if (url === 'support-ticket') {
        this.selectedItem = 3;
      }
      if (url === 'company-list') {
        this.selectedItem = 1;
        baseUrl += `?page=1`;
        if (this.filter_type) {
          baseUrl += `&filter_type=${this.filter_type}`;
        }
        if (this.filter_status) {
          baseUrl += `&filter_status=${this.filter_status}`;
        }
      } else {
        baseUrl = `/${url}`;
        this.selectedItem = 0;
      }
      this.$router.push(baseUrl);
    }
  },
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.v-application {
  line-height: 1.5;
  background: #f8fafc !important;
  font-family: "Inter", sans-serif !important;
}  
.container--fluid {
    padding: 0 !important; 
  }
  .grecaptcha-badge {
    display:none !important;
    box-shadow: none !important;
  }
.v-btn--active {
    background-color: #050550 !important;
  }
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
.headingprofile {
  text-align: left;
  h2 {
        color: #263238;
        font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.activeTab {
    background-color: #10b981;
    color: white;
    position: relative;
    text-align: center;
    padding: 10px;
}

.activeTab::after {
    content: "";
    position: absolute;
    bottom: -6px; 
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px; /* Size of the arrow */
    height: 12px;
    background-color: #10b981;
}
.v-list-item--active {

}
.am-sidebar {
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  .v-card {
      box-shadow: none !important;
          background: transparent;
  }
  .v-list-item {
    margin: 6px 12px;
    padding: 0px 12px;
    color: #000 !important;
  }
  .v-icon {
    color: #000;
        font-size: 20px;
  }
  .v-list-item--active {
    background-color: #6366f1 !important;
    color: #fff !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
  }

}
.mainStats {
  color: #0d0d60;
  font-size: 2rem;
  font-weight: 700;
}
.cardTitle {
  color: #0d0d60;
  margin: 0px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
}
.btn-soft-success {
  box-shadow: none !important;
  color: #6366F1 !important;
  background: #e1e2ff !important;
  border-color: transparent;
}
.title-soft-success {
  box-shadow: none !important;
  color: #6366F1 !important;
  background: #e1e2ff !important;
  border-color: transparent;
}
.btn-light {
  background-color: #f3f6f9;
  box-shadow: none !important;
  color: black
}
.btn-light:hover {
  background-color: #ced4da;
}
.btn-soft-success:hover {
  color: #fff !important;
  background: #6366F1 !important;
  border-color: transparent;
}
.btn-soft-secondary {
  box-shadow: none !important;
  color: #8B5CF6 !important;
  background: #d5c3fe !important;
  border-color: transparent;
  &.active {
    background: #8B5CF6 !important;
    color: white !important;
  }
}
.btn-soft-secondary:hover {
  color: #fff !important;
  background: #3577f1 !important;
  border-color: transparent;
}
.btn-soft-info {
  box-shadow: none !important;
  color: #299cdb !important;
  background: #dff0fa !important;
  border-color: transparent;
}
.btn-soft-info:hover {
  box-shadow: none !important;
  color: #fff !important;
  background: #299cdb !important;
  border-color: transparent;
}
.btn-soft-info2 {
  color: #299cdb !important;
  background: #dff0fa !important;
  border-color: transparent;
}
.btn-soft-info2:hover {
  box-shadow: none !important;
  color: #fff !important;
  background: #299cdb !important;
  border-color: transparent;
}
.v-btn {
  border-radius: 24px;
}
.tableDash {
  text-align: left;
  background-color: #f6f6f6;
  border-radius: 6px;
  margin: 24px 0;
}
.breadcrumbs {
  list-style: none;
  display: flex;
  background: #ffffff !important;
  padding: 6px !important;
  gap: 6px;
}

.breadcrumbs-item {
  padding: 8px 12px;
  color: #878a99 !important;
  text-decoration: none;
  letter-spacing: 1px;
  position: relative;
    background: #3b82f61f;
    border-radius: 24px;
        min-width: 70px;
    text-align: center;
  li {
    font-size: 14px;
  }
}
.breadcrumbs-item.top-menu--active {
  background: #6366f1;
  color: white !important;
  border-radius: 24px;
}

// .breadcrumbs-item::before,
// .breadcrumbs-item::after {
//   content: "";
//   position: absolute;
//   height: 100%;
//   width: 0.75rem;
//   top: 0;
//   left: -1px;
//   clip-path: polygon(0 0, 100% 50%, 0 100%);
// }

.breadcrumbs-item::before {
  background: #f1f5f9;
}

.breadcrumbs-item::after {
  left: 99.4% !important;
  background: var(--green-100);
}
.breadcrumbs-item.top-menu--active::after {
  background: #6366f1;
}

.breadcrumbs-item:first-child {
}

.breadcrumbs-item:first-child::before {
  display: none;
}

.breadcrumbs-item:last-child {
}

.breadcrumbs-item:last-child::after {
  display: none;
}

.breadcrumbs-item:hover,
.breadcrumbs-item:hover::after {
  background: #6366f1;
  color: #fff !important;
  border-radius: 24px;
}
.v-slide-group.v-item-group > .v-slide-group__next, .v-slide-group.v-item-group > .v-slide-group__prev {
      margin-bottom: 10px;
    max-width: 28px !important;
    min-width: 10px;
}
.v-btn > .v-btn__content .v-icon {
  font-size: 16px;;
}
.tableHead {
  background-color: rgb(99 102 241);padding: 24px 12px;color: white;
}
.v-input__slot {
  border-radius: 24px !important;
}
</style>
